import { FC } from 'react';
import { AllieToggleProps } from './Toggle.types';
import { StyledToggle } from './Toggle.styles';

export const AllieToggle: FC<AllieToggleProps> = (props) => <StyledToggle {...props} />;
